import {AbstractDrawLinestring} from "../abstract-draw-linestring";
import {ShapeGenerator} from "../../generators/shape-generator";
import {LayerGeometry} from "../../../document/model/layer";
import {Feature} from "geojson";
import {defineAsyncComponent} from "vue";
import {DrawInteractionState} from "../abstract-draw";
import {isOffline} from "../../../utils";

let MapMultiSave = defineAsyncComponent(() => import("../../../../components/map/MapMultiSave.vue"));

export class EditorSplitPolygon extends AbstractDrawLinestring {
  private feature: Feature;

  buildInitialState(initialState: DrawInteractionState): any {
    this.feature = initialState.features.get(initialState.featureID);

    let state = super.buildInitialState(initialState);
    this.displayDrawFeature(this.createFeature(this.feature));

    return state;
  }


  save(state: any, nextInteraction: string | undefined = undefined) {
    let layerGeometry = this.controller.interaction.getLayerGeometry(state.featureID);
    this.cut(layerGeometry, state)
      .then(() => {
        this.controller.reloadLayer(layerGeometry.document)
        this.mode.changeInteraction('select');
        this.controller.interaction.clearFocus(true);
      })
      .catch(() => {
        this.mode.resetInteraction();
      })
  }

  protected cut(layerGeometry: LayerGeometry, state: any) {
    return new Promise((resolve, reject) => {
      let resultCollection;
      try {
        switch (this.feature.geometry.type) {
          case 'MultiPolygon':
            resultCollection = {type: 'FeatureCollection', features: []};
            this.feature.geometry.coordinates.forEach(polygonCoordinates => {
              let subCollection = ShapeGenerator.cutPolygon({
                type: 'Feature',
                geometry: {type: "Polygon", coordinates: polygonCoordinates}
              }, this.line);
              if (subCollection.features.length === 1) {
                return;
              }

              resultCollection.features.push(...subCollection.features);
            });
            break;
          default:
            resultCollection = ShapeGenerator.cutPolygon(this.feature, this.line);
        }
      } catch (error) {
        console.error(error);
        this.controller.configuration.toastProvider({
          severity: 'error',
          summary: 'Error',
          detail: error ?? 'An error occurred'
        });
        reject();
        return;
      }

      if (resultCollection === undefined || resultCollection.features.length < 2) {
        reject();
        return;
      }

      this.layerGeometrySplit(layerGeometry, resultCollection.features).then(() => resolve(undefined));
    })
  }

  protected layerGeometrySplit(original: LayerGeometry, children: Feature[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this.controller.configuration.dialogProvider().open(
        MapMultiSave,
        {
          props: {
            header: this.controller.configuration.translatorProvider("Save split geometries"),
            style: {
              width: isOffline() ? "90vw" : "50vw",
            },
            modal: true
          },
          data: {
            features: children.map(layerGeometry => {
              let obj: any = {
                documentId: original.documentId,
                geometry: layerGeometry,
                properties: layerGeometry.properties,
              };
              if (original.document.properties?.header) {
                obj.attributes = original.document.properties.header;
              }
              return obj;
            }),
            splitData: {
              documentId: original.documentId,
              geometryId: (original as any).id || original.geometryId
            },
            originalGeometry: original,
            mapController: this.controller
          },
          onClose: (options) => {
            switch (options.type) {
              case "config-close":
                resolve(undefined);
                break;
            }
          }
        }
      );
    });
  }

}
